module.exports = __webpack_public_path__ + "static/media/other.9623ec22.png";